import { render, staticRenderFns } from "./AppFormInfo.vue?vue&type=template&id=6a70a55a&scoped=true&"
import script from "./AppFormInfo.vue?vue&type=script&lang=js&"
export * from "./AppFormInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppFormInfo.vue?vue&type=style&index=0&id=6a70a55a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70a55a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a70a55a')) {
      api.createRecord('6a70a55a', component.options)
    } else {
      api.reload('6a70a55a', component.options)
    }
    module.hot.accept("./AppFormInfo.vue?vue&type=template&id=6a70a55a&scoped=true&", function () {
      api.rerender('6a70a55a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppFormInfo.vue"
export default component.exports